<ng-content></ng-content>
<tt-list
    *ngIf="!('mobile' | mediaQuery) && !!(quickAccess.quickAccessList$ | async)"
    class="col-xs-12 col-md-3 sp-0"
    [ttData]="(quickAccess.quickAccessList$ | async)!"
    (ttClick)="quickAccessGoto($event)"
    [ttGoto]="false"
></tt-list>

<ul *ngIf="('mobile' | mediaQuery) && !!(quickAccess.quickAccessList$ | async)" class="quick-access__ul">
    <li class="quick-access__li" *ngFor="let item of quickAccess.quickAccessList$ | async">
        <button class="quick-access-item__button" (click)="quickAccessGoto({ item: item, event: $event })">
            <span class="fa-fw fad quick-access-item__icon" [ngClass]="getIcon(item)" [style.color]="item.item_glyphicon_color"></span>
            <span>{{ item.item_name }}</span>
        </button>
    </li>
</ul>
